import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import style from './style/expandtext.scss';

/** ExpandText Component
 *
 * Shows given text, collapsed by default with an expand button to control it. Optionally a resizeSection method can be
 * provided (together with index and handle), that is then used as callback to resize the grid item and report layout.
 * The section can be shown expanded by default using the expanded flag. Note that the resize method uses this too to
 * calculate the expanded height of the section.
 *
 * @example
 * <ExpandText
 *     text={ 'intro text' }
 *     classes={{ root: style.someOverrideClass }}
 *     resize={ event => resizeSection(event, index, handle) }
 *     index={ 1 }
 *     handle={ 'sectionHandle' }
 *     expanded={ false }
 * />
 */
export default class ExpandText extends Component {
    constructor(props) {
        super(props);

        /* initially the expandText is always rendered unexpanded unless it is specifically set to be */
        this.state = {
            open: this.props.expanded === true
        };

        this.expandText = this.expandText.bind(this);
    }

    expandText(event) {
        event.stopPropagation();

        // callback to resize method
        if (this.props.handle && this.props.resize && (this.props.index || this.props.index === 0)) {
            this.props.resize(event, this.props.index, this.props.handle);
        }

        this.setState({
            open: !this.state.open
        });
    }

    render() {
        const { text, classes, disabled } = this.props;

        return text ? <div
            role="button"
            tabIndex="-1"
            className={ `${style.expandText} ${classes.root}` }
            data-cy={ this.state.open ? 'expand-text expanded' : 'expand-text expand' }
            onClick={
                disabled
                    ? null
                    : event => {
                        this.expandText(event);
                    }
            }
        >
            <p
                className={ `${style.expandTextContent} ${this.state.open ? style.opened : ''}` }
                dangerouslySetInnerHTML={{ __html: text }}
            />
            <span
                role="button"
                tabIndex="-1"
                data-cy={ this.state.open ? 'expand-text expanded' : 'expand-text expand' }
                className={ style.expandTextButton }
            >
                { disabled ? null : <FontAwesomeIcon icon={ this.state.open ? 'chevron-up' : 'chevron-down' } /> }
            </span>
        </div> : null;
    }
}

ExpandText.propTypes = {
    text: PropTypes.string,
    index: PropTypes.number,
    handle: PropTypes.string,
    resize: PropTypes.func,
    expanded: PropTypes.bool,
    classes: PropTypes.shape({
        root: PropTypes.string
    }),
    disabled: PropTypes.bool
};

ExpandText.defaultProps = {
    text: null,
    classes: {
        root: ''
    },
    disabled: false
};
